/** Public assignment is presentation only. Authenticated tenant data is authoritative. */
export interface SessionEntitlements {
  tenantId: string;
  modules: Record<string, boolean>;
  products?: Record<string, boolean>;
  features?: Record<string, boolean>;
}
export function validClinicSession(me: SessionEntitlements | null, expected: string): boolean {
  return !!me && me.tenantId === expected;
}
export function sessionProductOn(me: SessionEntitlements | null, expected: string, key: string): boolean {
  return validClinicSession(me, expected) &&
    (me?.modules[key] === true || me?.products?.[key] === true);
}
